








































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'

@Component
export default class OrderListHeader extends Vue {
  private isActive: boolean = false

  @Prop() private isChangeList!: any

  @Watch('isChangeList')
  onChange (isChange: boolean) {
    if (isChange) {
      this.isActive = false
    }
    this.$emit('is-not-active')
  }

  private showAllInner () {
    this.isActive = !this.isActive
    this.$emit('show-all-inner')
  }

  /* ソート */
  private sortList (val: number) {
    this.isActive = false
    this.$emit('sort-order-list', val)
  }
}
